import { render, staticRenderFns } from "./DaysSwitch.vue?vue&type=template&id=0be5aa4e&lang=html&"
import script from "./DaysSwitch.vue?vue&type=script&lang=js&"
export * from "./DaysSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DaysSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VLabel,VMessages})
